import { ReactElement } from 'react'
import styled from 'styled-components'
import Spinner from './Spinner'
import placeholder from '../assets/placeholder.svg'

interface PlaceholderElementProps {
  height: number
  width: number
  background: string
}

interface PlaceholderProps {
  loading: boolean
  height: number
  width: number
  showBackground?: boolean
  children: any
}

const PlaceholderElement = styled.div<PlaceholderElementProps>`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Larsseit;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #919191;
  background-image: url(${(props) => props.background});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`
const TextContainer = styled.div`
  padding: 0 20px;
  text-align: center;
`

const Placeholder = ({
  loading,
  height,
  width,
  showBackground = false,
  children
}: PlaceholderProps): ReactElement => {
  return (
    <PlaceholderElement height={height} width={width} background={showBackground ? placeholder : ''}>
      {loading && <Spinner />}
      <TextContainer>
        {children}
      </TextContainer>
    </PlaceholderElement>
  )
}

Placeholder.defaultProps = {
  loading: false
}

export default Placeholder
